<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    class="mail-icon"
    :fill="color"
    :class="iconClass"
    @click="handleClick"
  >
    <path
      d="M140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm340-302L140-685v465h680v-465L480-462Zm0-60 336-218H145l335 218ZM140-685v-55 520-465Z"
    />
  </svg>
</template>
<script>
/**
 * @description Componente que exibe o icone de salvar
 */
export default {
  name: "MailIcon",
  inheritAttrs: false,
  props: {
    color: {
      type: String,
      default: "white",
    },
    size: {
      type: String,
      default: "1.5rem",
    },
  },
  computed: {
    iconColor() {
      switch (this.color) {
        case "white":
          return "mail-icon";
        case "black":
          return "mail-icon-black";
        default:
          return "mail-icon";
      }
    },
    iconSize() {
      switch (this.size) {
        case "x-small":
          return "x-small";
        case "small":
          return "small";
        case "medium":
          return "medium";
        case "large":
          return "large";
        default:
          return "medium";
      }
    },
    iconClass() {
      return this.iconColor + " " + this.iconSize;
    },
  },
  methods: {
    handleClick() {
      this.$emit("action");
    },
  },
};
</script>
<style scoped>
.mail-icon {
  width: 1.5rem;
  height: 1.5rem;
}

.mail-icon:hover {
  fill: var(--dl-color-gray-white);
  cursor: pointer;
}

.mail-icon-black {
  width: 1.5rem;
  height: 1.5rem;
}

.mail-icon-black:hover {
  fill: var(--dl-color-gray-700);
  cursor: pointer;
}

.x-small {
  width: 0.75rem;
  height: 0.75rem;
}

.small {
  width: 1rem;
  height: 1rem;
}

.medium {
  width: 1.25rem;
  height: 1.25rem;
}

.large {
  width: 2rem;
  height: 2rem;
}
</style>
